<script setup lang="ts">
import { ref } from 'vue'
import { RouterLink, RouterView } from 'vue-router'
import { siteConfig } from './config/site'

const menuOpen = ref(false)
const nav = [
  ['Políticos', '/'], ['Flávio Bolsonaro', '/flavio-bolsonaro'], ['Jair Bolsonaro', '/jair-bolsonaro'], ['Dossiês', '/casos'], ['Comparações', '/comparacoes'], ['Relações', '/relacoes'], ['Como checamos', '/criterio-editorial'],
]
</script>

<template>
  <a class="skip-link" href="#conteudo">Pular para o conteúdo</a>
  <header class="site-header">
    <div class="header-inner">
      <RouterLink class="brand" to="/">
        <span class="brand-mark">RP</span><span>{{ siteConfig.name }}<small>{{ siteConfig.subject }}</small></span>
      </RouterLink>
      <button class="menu-button" :aria-expanded="menuOpen" aria-controls="site-nav" @click="menuOpen = !menuOpen">{{ menuOpen ? 'Fechar' : 'Menu' }}</button>
      <nav id="site-nav" :class="{ open: menuOpen }" aria-label="Navegação principal">
        <RouterLink v-for="item in nav" :key="item[1]" :to="item[1]" @click="menuOpen = false">{{ item[0] }}</RouterLink>
      </nav>
    </div>
  </header>
  <main id="conteudo"><RouterView /></main>
  <footer class="site-footer">
    <div class="footer-grid">
      <div><span class="eyebrow">Arquivo público verificável</span><h2>{{ siteConfig.tagline }}</h2></div>
      <div><p>Encontrou um erro ou uma fonte nova? A correção entra de forma visível e datada.</p><a :href="`mailto:${siteConfig.correctionsEmail}`">Comunicar erro ou enviar fonte</a></div>
      <div><p>Última atualização do acervo: <time :datetime="siteConfig.lastEditorialReview">{{ siteConfig.lastEditorialReview.split('-').reverse().join('/') }}</time></p><RouterLink to="/criterio-editorial">Como checamos</RouterLink></div>
    </div>
  </footer>
</template>
